import type { TourDefinition } from '../../types';
import { T02 } from './T02';
import { T03 } from './T03';
import { T04 } from './T04';
import { T05 } from './T05';
import { T06 } from './T06';
import { T07 } from './T07';
import { T08 } from './T08';
import { T09 } from './T09';
import { T11 } from './T11';

/**
 * The task guides (brief §7): T02–T09 in the tenant workspace and T11 in the
 * supplier portal, one file each. The orientations T01, T10 and T12 (which
 * continue into record steps) are in `../orientation`. Copy is in
 * `./locales/{en,ar}.json` under `guidance.tours.<id>.*`, merged by the
 * locale-fragment loader — all of it DRAFT for native-language review.
 */
export const TASK_TOURS: readonly TourDefinition[] = [T02, T03, T04, T05, T06, T07, T08, T09, T11];
